module.exports = __webpack_public_path__ + "assets/search-slider-mobile.3ee719a6.svg";